import { Templates } from '@domains/subscription/Templates'
import { useCreateTemplate, useGetTemplates } from '../api/queries'
import { CreateTemplateDialog } from '../CreateTemplateDialog'
import type { CreateTemplateFormData } from '../types'

interface SubscriptionPlanListProps {
  navigateToTemplate: (templateId: string) => void
}

export const SubscriptionPlanList = ({ navigateToTemplate }: SubscriptionPlanListProps) => {
  const { data: templates = [], isLoading } = useGetTemplates()
  const deleteTemplate = (templateId) => console.log(`Will delete template with id ${templateId} in the future`)
  const saveTemplate = useCreateTemplate()

  return (
    <Templates
      templates={templates}
      isLoading={isLoading}
      onDeleteTemplate={deleteTemplate}
      onSaveTemplate={async (templateFormData: CreateTemplateFormData) => {
        const templateId = await saveTemplate.mutateAsync({
          name: templateFormData.name,
          externalName: templateFormData.externalName,
          eligibility: templateFormData.eligibility,
        })

        navigateToTemplate(templateId.id)
      }}
      onNavigateToTemplate={navigateToTemplate}
      CreateTemplateDialog={CreateTemplateDialog}
    />
  )
}
